import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsCommitsRoute} from '../routes/commits-route'
import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'

export function useCommitsLiveUpdates(channel: string, throttleTimeout?: number): void {
  const {refetch} = useRouteQuery(pullRequestsCommitsRoute, 'mainQuery')
  // The default number for the throttle timeout is 2000ms
  useRefetchOnAliveUpdate(channel, refetch, {git_updated: true}, throttleTimeout)
}
